/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router";
import { Loader } from "../loader";
import { checkAdmin } from "../../utils/checkAdmin";

/**
 * Renders its page only for OwnersTable staff (super admins and Super Viewers). Anyone else is sent to the
 * dashboard before the page mounts, so a group-scoped role never sees it and it sends none of its requests.
 * Waits for the admin to load instead of redirecting staff while /me is in flight.
 */
export const OwnersTableStaffRoute = ({ children }) => {
  const admin = useSelector((state) => state.admin?.admin);

  if (!admin) return <Loader />;
  if (!checkAdmin(admin.formatted_roles)) return <Navigate to="/admin/dashboard" replace />;

  return children;
};
